import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Taxon} from "../../../domain/Taxon";
import {LocalService} from "../../../services/LocalService";
import {FaunaDataSource} from "../../../services/persist/FaunaDataSource";
import {IRepository} from "../../../services/persist/IRepository";
import {Grupo} from "../../../domain/enums";

@Component({
  selector: 'app-taxon-search',
  templateUrl: './taxon-search.component.html',
  styleUrls: ['./taxon-search.component.scss'],
})
export class TaxonSearchComponent {
  public results: Taxon[] = [];
  private repo: IRepository<Taxon>
  @Input()
  grupos: Grupo[]

  constructor(ds: FaunaDataSource) {
    this.repo = ds.getRepository(Taxon)
  }


  async handleInput(event: any) {
    let query = event.target.value.toLowerCase()
    if(!query.endsWith("*") && query.length >=2) query+="*"

    this.results = await this.repo.findTaxon(this.grupos, query)
    console.log('resultado', this.results.length)
  }

  isOpen = false;
  localService = new LocalService()
  @Input()
  taxon?: Taxon

  selecionar(item: Taxon){
    this.taxon = item
    this.isOpen = false
    this.taxonChange.emit(this.taxon)
  }

  @Output()
  taxonChange = new EventEmitter<Taxon>();

  voltar(){
    this.isOpen = false
  }

  open() {
    this.isOpen = true;
  }

}
